import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { MouseInput } from '../../../platform/input/MouseInput';
import { resolve } from '../../Container';
import { ToolBehavior } from './ToolBehavior';
import { toolReset } from './ToolCommands';

export class InstantDequipToolBehavior extends ToolBehavior {

    @resolve(CommandDispatcher) private dispatch: CommandDispatcher;

    public onMouseDown(_state: string, _e: MouseInput): string | void {
        return 'resetting';
    }

    public onMouseUp(state: string, _e: MouseInput): string | void {
        if (state === 'resetting') {
            this.dispatch(toolReset);
        }
    }
}
